import { render, staticRenderFns } from "./TheTickets.vue?vue&type=template&id=034c43f0&scoped=true&"
import script from "./TheTickets.vue?vue&type=script&lang=ts&"
export * from "./TheTickets.vue?vue&type=script&lang=ts&"
import style0 from "./TheTickets.vue?vue&type=style&index=0&id=034c43f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c43f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034c43f0')) {
      api.createRecord('034c43f0', component.options)
    } else {
      api.reload('034c43f0', component.options)
    }
    module.hot.accept("./TheTickets.vue?vue&type=template&id=034c43f0&scoped=true&", function () {
      api.rerender('034c43f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheTickets.vue"
export default component.exports